import { render } from "./FieldTitle.vue?vue&type=template&id=f60ab12a"
import script from "./FieldTitle.vue?vue&type=script&lang=js"
export * from "./FieldTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__